// extracted by mini-css-extract-plugin
export default {"squiggleDivider":"SquiggleDivider__squiggleDivider__cgjRd"};